export default {
  historiqueAbonnements: [],
}
